import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export const STAT_TYPES = {
  PASSING: 'PASSING',
  RUSHING: 'RUSHING',
  RECEIVING: 'RECEIVING',
  BLOCKING: 'BLOCKING',
  DEFENSE: 'DEFENSE',
  KICKING: 'KICKING'
};

export const STAT_COLUMNS = {
  [STAT_TYPES.PASSING]: ['POS', 'NAME', 'TEAM', 'CMP', 'ATT', 'CMP%', 'YRDS', 'TD', 'INT', 'PICK6', 'FUM', 'AVG', 'QBR'],
  [STAT_TYPES.RUSHING]: ['POS', 'NAME', 'TEAM', 'ATT', 'YRDS', 'TDS', 'FUM', 'AVG', 'LONG'],
  [STAT_TYPES.RECEIVING]: ['POS', 'NAME', 'TEAM', 'REC', 'TRGT', 'REC%', 'YRDS', 'TDS', 'FUM', 'AVG', 'LONG'],
  [STAT_TYPES.BLOCKING]: ['TEAM', 'ABV', 'DP', 'SNPS', 'SKA'],
  [STAT_TYPES.DEFENSE]: ['POS', 'NAME', 'TEAM', 'TCK', 'TFL', 'SCK', 'SFTY', 'FF', 'FR', 'FRTD', 'INT', 'PBU', 'TD'],
  [STAT_TYPES.KICKING]: ['POS', 'NAME', 'TEAM', 'XPM', 'XPA', 'XP%', 'FGM', 'FGA', 'FG%', 'K%', 'PNTS', 'LONG']
};

export const TABLE_NAMES = {
  [STAT_TYPES.PASSING]: 'passing_stats',
  [STAT_TYPES.RUSHING]: 'rushing_stats',
  [STAT_TYPES.RECEIVING]: 'receiving_stats',
  [STAT_TYPES.BLOCKING]: 'blocking_stats',
  [STAT_TYPES.DEFENSE]: 'defense_stats',
  [STAT_TYPES.KICKING]: 'kicking_stats'
};

export const fetchStatsFromTable = async (statType) => {
  try {
    const tableName = TABLE_NAMES[statType];
    if (!tableName) {
      throw new Error(`Unknown stat type: ${statType}`);
    }

    const { data, error } = await supabase
      .from(tableName)
      .select('*')
      .order('id', { ascending: true });

    if (error) {
      console.error(`Error fetching ${statType} stats:`, error);
      return [];
    }

    return data.map(row => {
      const converted = {};
      STAT_COLUMNS[statType].forEach((col) => {
        const dbCol = col.toLowerCase();
        converted[col] = row[dbCol] !== undefined ? row[dbCol] : '';
      });
      return converted;
    });
  } catch (error) {
    console.error(`Error in fetchStatsFromTable for ${statType}:`, error);
    return [];
  }
};

export const fetchAllStats = async () => {
  const stats = {};
  for (const statType of Object.values(STAT_TYPES)) {
    stats[statType] = await fetchStatsFromTable(statType);
  }
  return stats;
};

export const searchPlayers = (allStats, searchTerm) => {
  const lowerSearchTerm = searchTerm.toLowerCase();
  const results = {};

  Object.keys(allStats).forEach((statType) => {
    results[statType] = allStats[statType].filter(player => {
      const searchField = statType === STAT_TYPES.BLOCKING ? (player.TEAM || '') : (player.NAME || '');
      return searchField.toLowerCase().includes(lowerSearchTerm);
    });
  });

  return results;
};
